<div class="p-2">
  <p class="text-[15px] font-bold text-[var(--base-text-dark)] mb-2">BACK</p>
  <p class="text-[13px] text-[var(--tertiary-text)] mb-5">All changes will be lost, are you sure?</p>
  <div class="flex items-center gap-2.5">
    <button (click)="cancel()"
      class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      CANCEL
    </button>
    <button (click)="back()"
      class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">arrow_back</span> BACK
    </button>
  </div>
</div>
